export default function WhereWeAreGoing() {
  return (
    <section className="relative py-12 sm:py-16 lg:py-24 overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://static.readdy.ai/image/57c982531ce74d8992a8785896e0bafd/3af21a0d2dc93cb2cf0e4e91819d84d8.jpeg)'
        }}
      ></div>
      
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      
      {/* Content */}
      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-6 sm:mb-8">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-3 sm:mb-4">
            Where We're Going
          </h2>
          <div className="w-12 sm:w-16 h-1 bg-green-500 mx-auto rounded-full"></div>
        </div>
        
        <div className="max-w-4xl mx-auto mb-8 sm:mb-10">
          <p className="text-sm sm:text-base md:text-lg lg:text-xl text-white/95 leading-relaxed text-center font-light mb-8 sm:mb-10 px-2">
            What started as a handful of dream rounds has grown into a nationwide movement—over 20 events planned for 2026 already with a waitlist of golfers eager to join our journey. As we continue to grow, our focus remains the same: to deliver the most authentic, memorable, and exclusive golf experiences anywhere in the world.
          </p>
        </div>

        <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 sm:p-8 text-center shadow-xl border border-white/20">
          <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-white mb-3 sm:mb-4">
            Why We Do This
          </h3>
          <p className="text-sm sm:text-base md:text-lg text-white/95 leading-relaxed max-w-3xl mx-auto font-light px-2">
            Because true golf isn't just about playing the best—it's about playing with the best. It's about belonging to something bigger than yourself. The Bucket List Series is where passion, tradition, and adventure meet. And for our members, it's simply home.
          </p>
        </div>
      </div>
    </section>
  );
}
